import * as React from 'react';
import classnames from 'classnames';
import cls from './checkbox.module.scss';
import Check from './Check';

// @flow
export type CheckboxProps = JSX.IntrinsicElements['input'] & {
  className?: string;
  label?: React.ReactNode;
  description?: React.ReactNode;
  toggle?: boolean;
  radio?: boolean;
  color?: 'green' | 'blue' | 'orange' | 'violet' | 'red';
};

export const Checkbox = ({
  label,
  className,
  description,
  toggle,
  radio,
  name,
  color,
  ...rest
}: CheckboxProps) => (
  <label
    className={classnames(cls.wrapper, className, {
      [cls.toggle]: toggle,
      [cls.radio]: radio,
    })}
  >
    <input className={cls.checkbox} name={name} type="checkbox" {...rest} />
    <div
      className={classnames(cls.label, {
        [color]: color,
      })}
    >
      {!toggle && !radio && <Check />}
      {label}
    </div>
    {description && <p className={cls.description}>{description}</p>}
  </label>
);

Checkbox.defaultProps = {
  label: null,
  className: null,
  description: null,
  toggle: false,
  radio: false,
  color: 'green',
};

export default Checkbox;
